import { FetcherMode, fetcherTokenIdAtom, sharedBasketQuerySelector } from "@keepeek/commons";
import { selectorFamily } from "recoil";

import { textTemplatingEvaluateSelector } from "../../textTemplating/selectors";

export type TextTemplatingFetcher = {
  evaluate: (text: string) => string;
};

export const textTemplatingFetcherSelector = selectorFamily<TextTemplatingFetcher, FetcherMode>({
  key: "TextTemplatingFetcherSelector",
  get:
    (mode) =>
    ({ get }) => {
      switch (mode) {
        case FetcherMode.SHARE:
          const tokenId = get(fetcherTokenIdAtom);
          const sharedBasket = get(sharedBasketQuerySelector(tokenId));

          return {
            evaluate: (text) => {
              return get(textTemplatingEvaluateSelector({ text, objects: { sharedBasket } }));
            },
          };
        default:
          return {
            evaluate: (text) => {
              return get(textTemplatingEvaluateSelector({ text, objects: {} }));
            },
          };
      }
    },
});
